import ManufacturerMap, {ManufacturerMapLocation} from "../map/manufacturer-map";
import ViewSwitcher from "../view-switcher";
import App from "../../app";

export default class SingleProduct {
    private readonly elem: HTMLElement;

    private manufacturerMap: ManufacturerMap;

    private viewSwitcher: ViewSwitcher;

    constructor(elem: HTMLElement) {
        this.elem = elem;
        this.viewSwitcher = new ViewSwitcher([
            {
                id: 'content',
                el: this.elem.querySelector('[data-id-view="content"]') as HTMLElement
            },
            {
                id: 'map',
                el: this.elem.querySelector('[data-id-view="map"]') as HTMLElement
            }
        ])

        this.initMap();
    }

    public static factory() {
        const elem = document.querySelector('body.single-product') as HTMLElement;

        if (elem) {
            new SingleProduct(elem);
        }
    }

    public initMap(): void {
        this.elem.querySelector('[data-action="show-map"]').addEventListener('click', () => this.viewSwitcher.show('map'));
        //this.elem.querySelector('[data-action="close-map"]').addEventListener('click', () => this.viewSwitcher.show('content'));

        this.viewSwitcher.on('activated', (e) => {
            if (e.view.id === 'map') {
                this.openMap([App.getData('manufacturer.location')]);
            } else {
                this.closeMap();
            }
        });
    }

    public openMap(manufacturers: Array<ManufacturerMapLocation>) {
        this.manufacturerMap = new ManufacturerMap(this.viewSwitcher.getView('map').el.querySelector('._js-map'));

        manufacturers.forEach((manufacturer) => {
            this.manufacturerMap.addLocation(manufacturer);
        });

        this.manufacturerMap.update();
    }

    public closeMap() {
        if (this.manufacturerMap) {
            this.manufacturerMap.destroy();
            this.manufacturerMap = null;
        }
    }
}